/**
 * Funciones de cálculo y estadísticas de envíos
 */

/**
 * Calcula el total de bultos
 */
export const calcularTotalBultos = (envios) => {
    return (envios ?? []).reduce((acc, e) => {
        const n = Number(e?.bultos);
        return acc + (Number.isFinite(n) ? n : 0);
    }, 0);
};

/**
 * Cuenta el número de expediciones únicas
 */
export const contarExpediciones = (envios) => {
    return new Set(
        (envios ?? [])
            .map((e) => String(e?.expedicionAsigna ?? "").trim())
            .filter((v) => v !== "")
    ).size;
};
